<template>
  <v-app>
    <Navbar/>
    <v-content>
    
  <v-card bordered  light  
    class="mx-5 my-5">
          <v-container grid-list-sm class="pa-4 add_item_vue" > 
            <v-layout row wrap>       
                       <v-flex xs12>
                <v-layout align-center class="mb-5  ml-5">
               <h2>Lähetä uusien tuotteiden posti kaikille asiakkaille:</h2>
                <v-btn  @click="SendNewMail()" large color="red" dark>Lähettää</v-btn>
                </v-layout>
       </v-flex>
             
        <v-flex xs12>
                <v-layout align-center class="mb-5  ml-5">
               <h2>Mail alensi tuotteita kaikille asiakkaille:</h2>
                <v-btn  @click="SendCampMail()" large color="red" dark>Lähettää</v-btn>
                </v-layout>                             
              </v-flex>
 </v-layout>
          </v-container>
              </v-card>
      <!-- <form @submit.prevent="sendPush" enctype="multipart/form-data">
        <v-card bordered  white  
    class="mx-5">
     <v-container grid-list-sm class="pa-4 add_item_vue" > 
              <v-flex xs12 align-center justify-space-between>               
                <h3>Otsikko</h3>
                       <v-layout align-center>
                  <v-text-field
                    class="mb-2"
                    placeholder="Otsikko"
                    required
                    v-model="title"
                  ></v-text-field>
                </v-layout>                   
              </v-flex>
              <v-flex xs12>
                <h3>Sisältö</h3>
                <v-text-field
                    
                    placeholder="Sisältö"
                    required
                    v-model="body"
                  ></v-text-field>
        
              </v-flex>
    
              <v-flex xs12>
                <v-btn type="submit" block class="main_color" dark>Lähetä ilmoitus kaikille asiakkaille</v-btn>
              </v-flex>

      
                 </v-container>
        </v-card>
      </form> -->
    </v-content>
  </v-app>
</template>

<script>
import Navbar from '@/components/admin/navbar/Navbar'
import firebase from "firebase";
import moment from 'moment'
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  name:'Push',
  components:{
    Navbar,VueEditor
  },
  data(){
    return{
      body:null,
      title:null,

      timestamp:null,
      loading: null,
      content: "<h1>Some initial content</h1>"
    }
  },
  watch: {
      loading (val) {
        if (!val) return
        setTimeout(() => (this.loading = false), 4000)
      },
  }, 
  methods:{
    SendNewMail(){
let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendNewProductsMail").
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });
    },
     SendCampMail(){
let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendCampProductsMail").
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });
    },
      sendPush(){
       //   var db = firebase.firestore();
          if(this.body){

 let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/SendPushAll?title="+this.title+"&body="+this.body).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });

          // let ref = db.collection('items');
          //   ref.add({
          //     item_name:this.item_name,
          //     price:this.price,             
          //     item_category:this.item_category,
          //     image:this.image,
          //     details:this.details,
          //     featured:this.featured,
          //     total:parseFloat(this.price * this.quantity),
          //     adding_date:moment().format('DD-MM-YYYY'),
          //     created_month:moment().format('MM-YYYY'),
          //     created_year:moment().format('YYYY'),
          //     timestamp:Date.now()
          //   })

            this.title=null
            this.body=null
         
          }
         // this.$router.push({ name: 'Items'})
      }   
   },
   created(){

      //  // Show All Categories
      //  var db = firebase.firestore();
      //  let ref = db.collection('item_categories').orderBy('timestamp', 'desc')

      //  ref.onSnapshot(snapshot => {
      //    snapshot.docChanges().forEach(change => {
      //      if(change.type == 'added'){
      //        let doc = change.doc
      //        this.item_categories.push({
      //          id:doc.id,
      //          category_name:doc.data().category_name
      //        })
      //      }
      //    })
      //  })
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/messaging/Push.vue